<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :readonly="board.readonly" :types="['department', 'com_name', 'rank', 'writer_name', 'date']" :typeslabel="{ date: '등록일' }" />

    <!-- 종사자 정보 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 종사자 정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>지역</div>
          <p v-if="isPrint" class="print-input">{{ form.지역 }}</p>
          <ml-input v-else v-model="form.지역" readonly />
        </div>
        <div>
          <div>급별</div>
          <p v-if="isPrint" class="print-input">{{ form.급별 }}</p>
          <ml-input v-else v-model="form.급별" readonly />
        </div>
        <div>
          <div>학교(기관)명</div>
          <p v-if="isPrint" class="print-input">{{ form.기관 }}</p>
          <FieldSelector v-else :readonly="board.readonly" v-model="form.기관" :fieldName="form.기관Data ? form.기관Data.field_name : ''" @select="onSelectFieldSelector" />
        </div>
        <div>
          <div>직종</div>
          <p v-if="isPrint" class="print-input">{{ form.직종 }}</p>
          <vs-select v-model="form.직종" autocomplete :readonly="board.readonly">
            <vs-select-item v-for="option in ['급식종사자', '시설관리자', '통학차량 관련자', '미화원', '당직전담원']" :key="option" :value="option" :text="option" />
          </vs-select>
        </div>
        <div>
          <div>성명</div>
          <p v-if="isPrint" class="print-input">{{ form.성명 }}</p>
          <ml-input v-else v-model="form.성명" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 교육 정보 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 교육 정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>연도</div>
          <p v-if="isPrint" class="print-input">{{ form.연도 }}</p>
          <vs-input v-else type="number" v-model="form.연도" :readonly="board.readonly" />
        </div>
        <div>
          <div>반기</div>
          <p v-if="isPrint" class="print-input">{{ form.반기 }}</p>
          <div v-else class="time">
            <vs-radio v-model="form.반기" vs-name="반기" vs-value="상반기" :readonly="board.readonly">상반기</vs-radio>
            <vs-radio v-model="form.반기" vs-name="반기" vs-value="하반기" :readonly="board.readonly">하반기</vs-radio>
          </div>
        </div>
        <div>
          <div>이수여부</div>
          <p v-if="isPrint" class="print-input">{{ form.이수여부 }}</p>
          <div v-else class="time">
            <vs-radio v-model="form.이수여부" vs-name="이수여부" vs-value="이수" :readonly="board.readonly">이수</vs-radio>
            <vs-radio v-model="form.이수여부" vs-name="이수여부" vs-value="미이수" :readonly="board.readonly">미이수</vs-radio>
            <ml-input v-model="form.미이수사유" :readonly="form.이수여부 !== '미이수' || board.readonly" style="width: 280px" />
          </div>
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <FileUploadModule id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FieldSelector from "@/components/selector/FieldSelector";
import DateSelector from "@/components/selector/DateSelector";
import FileUploadModule from "@/views/modules/FileUploadModule";

import { required } from "vuelidate/lib/validators";

export default {
  components: { FieldSelectModule, FieldSelector, DateSelector, FileUploadModule },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },  
  validations: {
    form: {
      기관Data: { required },
    },
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    postId() {
      return this.$route.params.postId;
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    "form.이수여부": {
      immediate: true,
      handler(value) {
        if (value === "이수") {
          this.form.미이수사유 = "";
        }
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        지역: "",
        급별: "",
        기관: "",
        기관Data: null,
        직종: "",
        성명: "",
        연도: new Date().getFullYear(),
        반기: "",
        이수여부: "",
        미이수사유: "",
        fileList: [],
      },
    };
  },
  methods: {
    onSelectFieldSelector(value) {
      if (value.address) {
        const si = ["목포", "여수", "순천", "나주", "광양", "담양", "곡성", "구례", "고흥", "보성", "화순", "장흥", "강진", "해남", "영암", "무안", "함평", "영광", "장성", "완도", "진도", "신안"];
        si.map((_si) => {
          if (value.address.includes(_si)) {
            this.form.지역 = _si;
          }
        });
      } else {
        this.form.지역 = "";
      }
      this.form.급별 = value.facility_category.cat3;

      this.form.기관Data = value;
    },
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.기관Data.required) return "학교(기관)명은 반드시 입력해야 합니다";
      }
    },
  },
};
</script>
